import { InView } from 'react-intersection-observer'
import styled from '@emotion/styled'
import React, { useState } from 'react'
import { css, keyframes } from '@emotion/react'
import { RichTextField, RTNode } from '@prismicio/client'
import { PrismicRichText } from '@prismicio/react'

export function FadeInWholeBlock(props: { children: React.ReactNode }) {
  const [visible, setIsVisible] = useState(false)

  return (
    <FadeInContainer
      threshold={1.0}
      onChange={(inView) => {
        if (inView) {
          setIsVisible(true)
        }
      }}
      visible={`${visible}`}
    >
      {props.children}
    </FadeInContainer>
  )
}

const FadeInContainer = styled(InView)<{ visible: string }>`
  transition: opacity 0.7s ease-in-out;
  opacity: ${({ visible }) => (visible === 'true' ? '1' : '0')};
`

export function FadeInParagraphByParagraph(props: { richText: RichTextField }) {
  const [isVisible, setIsVisible] = useState<boolean>(false)

  return (
    <InView
      threshold={0.7}
      onChange={(inView) => {
        if (!isVisible && inView) {
          setIsVisible(true)
        }
      }}
    >
      {props.richText.map((node: RTNode, index: number) => (
        <ParagraphByParagraphContainer
          visible={`${isVisible}`}
          delay={index * 0.2}
          key={index}
        >
          <PrismicRichText field={[node]} />
        </ParagraphByParagraphContainer>
      ))}
    </InView>
  )
}

const fadeInFromLeft = keyframes`
  0% {
      opacity: 0;
      transform: translateX(-50px);
  }
  100% {
      opacity: 1;
      transform: translateX(0);
  }
`

const ParagraphByParagraphContainer = styled.div<{
  visible: string
  delay: number
}>`
  opacity: 0;
  ${({ visible, delay }) =>
    visible === 'true' &&
    css`
      animation: ${fadeInFromLeft} 0.5s ease-in-out ${delay}s forwards;
    `}
`
